import { Button, Intent } from "@focus/focusUI";
import React from "react";
import { ListContext } from "../focusList/ListContext";
import EpochText from "./EpochText";
export const EpochWithClear = (props) => {
    const { onChange } = props;
    return (React.createElement("div", { className: "dateInput-with-clear", role: "dateInput-with-clear" },
        React.createElement(ListContext.Provider, { value: true },
            React.createElement(EpochText, Object.assign({}, props))),
        React.createElement("div", null,
            React.createElement(Button, { intent: Intent.DANGER, onClick: () => onChange(null), icon: "disable", className: "inlined-units focus-erase-button", role: "focus-erase-button" }))));
};
//# sourceMappingURL=EpochWithClear.js.map